let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cZW0M")).then(() => parcelRequire('k5UMG'));